import { render, staticRenderFns } from "./ProductViewSuppliers.vue?vue&type=template&id=3fc53943"
import script from "./ProductViewSuppliers.vue?vue&type=script&lang=js"
export * from "./ProductViewSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports